
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IContainerTypesModel,
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel,
} from "@/api/types";
import { QuotationApprovalDetail, QuotationApproval } from "./types";

import Pagination from "@/components/Pagination/index.vue";
import { removeQuotation } from "@/api/inquiry";

import {
  getDetails,
  downloadDetails,
  getStatus,
  getPaymentType,
} from "@/api/supplier-payment";
import { Moment } from "moment";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
// import { isShallow } from "vue";
import { setRemark } from "@/api/supplier-payment";

@Component({
  name: "PaymentOrderDetails",
  components: {
    Pagination,
    CreateFee: () => import("./components/CreateFee.vue"),
    CreatePayment: () => import("./components/CreatePayment.vue"),
    CreateClaim: () => import("./components/CreateClaim.vue"),
    Receipt: () => import("./components/Receipt.vue"),
    shipment: () => import("./components/shipment.vue"),
    relation: () => import("./components/relation.vue"),
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private showFee = false;
  private showAmount = false;
  private selectedItem = {} as any;
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();
  public showEditButtons = false;

  private conversionExchangeRate = 0;

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [{}] as QuotationApprovalDetail[],
  };

  public customerInfo = {} as any;
  public paymentForm = {
    settlementMethod: "",
    paymentMethod: "",
    accountPeriod: 0,
    paymentRemark: "",
    piAuditor: "",
    internationalTradeTerms: "",
    printLabel: true,
    deposit: true,
    depositAmount: 0,
    depositCurrency: "",
    confirmed: true,
    markList: [],
  } as any;
  private list = [
    {
      label: "付款单号码",
      prop: "code",
      key: "code",
    },
    {
      label: "付款单状态",
      prop: "state",
      key: "state",
    },
    {
      label: "付款性质",
      prop: "type",
      key: "type",
    },
    {
      label: "",
    },
    {
      label: "供应商名称",
      prop: "supplier",
      key: "supplier",
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
    },
    {
      label: "应付会计",
      prop: "accountant",
      key: "accountant",
    },
    {
      label: "货款金额",
      prop: "shipmentAmount",
      key: "shipmentAmount",
    },
    {
      label: "额外费用",
      prop: "otherFee",
      key: "otherFee",
    },
    {
      label: "采购订单费用",
      prop: "purchaseOrderFee",
      key: "purchaseOrderFee",
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
    },
    {
      label: "",
    },
    {
      label: "",
    },
    {
      label: "付款日期",
      prop: "paymentTime",
      key: "paymentTime",
    },
    {
      label: "付款单生成日期",
      prop: "createdTime",
      key: "createdTime",
    },
  ];
  private slList = [
    {
      label: "单据创建时付款剩余",
      prop: "supplierPaymentRemaining",
      key: "supplierPaymentRemaining",
    },
    {
      label: "单据创建时定金剩余",
      prop: "supplierCashRemaining",
      key: "supplierCashRemaining",
    },
    {
      label: "采购订单费用剩余",
      prop: "purchaseOrderFeeRemaining",
      key: "purchaseOrderFeeRemaining",
    },
    {
      label: "当前付款剩余",
      prop: "trendSupplierPaymentRemaining",
      key: "trendSupplierPaymentRemaining",
    },
    {
      label: "当前定金剩余",
      prop: "trendSupplierCashRemaining",
      key: "trendSupplierCashRemaining",
    },
    {
      label: "",
    },
  ];
  private list2 = [
    {
      label: "采购订单号",
      prop: "paymentMethod",
      key: "paymentMethod",
      type: "input",
      maxlength: 10,
    },
    {
      label: "装箱单号",
      prop: "paymentMethod",
      key: "paymentMethod",
      type: "input",
      maxlength: 10,
    },
    {
      label: "填写备注",
      prop: "paymentMethod",
      key: "paymentMethod",
      type: "textarea",
      maxlength: 100,
    },
  ];
  private id = "";
  private paymentInfo = {};
  private piInfo = {};

  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id as string;
    } else {
      this.id = this.$route.query.id as string;
    }
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getDetails();
  }

  private async downloadDetails() {
    await downloadDetails(this.id);
  }

  private editButtons() {
    this.showEditButtons = !this.showEditButtons;
  }

  private async getDetails() {
    const res: any = await getDetails(this.id);
    const {
      paymentVoucherOtherFeeResList,
      relationPaymentVoucherResList,
      shipmentDetailResList,
      supplierId,
      relationClaimFormResList
    } = res;
    (this.$refs.otherFees as any).table.list = paymentVoucherOtherFeeResList;
    (this.$refs.createPayment as any).table.list =
      relationPaymentVoucherResList;
    (this.$refs.createPayment as any).supplierId = supplierId;
    (this.$refs.shipment as any).table.list = shipmentDetailResList;
    (this.$refs.createClaim as any).table.list = relationClaimFormResList;
    this.paymentForm = {
      ...res,
    };
    console.log(this.paymentForm);

    this.paymentForm.type = await this.getPaymentType(res.type);
    this.paymentForm.state = await this.getStatus(res.state);
  }

  private async getStatus(value: string) {
    const res: any = await getStatus();
    return res.find((item: any) => item.name === value).desc;
  }

  private async getPaymentType(value: string) {
    const res: any = await getPaymentType();
    return res.find((item: any) => item.name === value).desc;
  }

  private handleSuccess() {
    this.showFee = false;
    this.getDetails();
  }

  // 删除关联索赔单成功后，更新付款单金额。前端静态处理，不重新调接口
  private deletedRelationClaim(amount: number) {
    const current = Number(this.paymentForm.paymentAmount ?? 0);
    const delta = Number(amount ?? 0);
    this.$set(this.paymentForm, "paymentAmount", current + delta);
  }

  // 编写备注
  public async handleRemark(e: string) {
    try {
      await setRemark(this.id, {
        remark: e,
      });
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.$emit("success", false);
    } catch (e) {
      this.$emit("success", false);
    }
  }
  //采购订单
  public purchase = [
    {
      label: "采购订单号",
      prop: "code",
      key: "code",
    },
    {
      label: "供应商简称",
      prop: "supplierAbb",
      key: "supplierAbb",
    },
    {
      label: "下单日期",
      prop: "orderDate",
      key: "orderDate",
    },
    {
      label: "约定交期",
      prop: "contractualDeliveryDate",
      key: "contractualDeliveryDate",
    },
    {
      label: "交货数量",
      prop: "quantity",
      key: "quantity",
    },
    {
      label: "交货金额",
      prop: "amount",
      key: "amount",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
    },
  ];
  private purchaseOrderFee = [
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
    },
    {
      label: "供应商简称",
      prop: "supplierAbbr",
      key: "supplierAbbr",
    },
    {
      label: "下单日期",
      prop: "orderDate",
      key: "orderDate",
    },
    {
      label: "费用名称",
      prop: "name",
      key: "name",
    },
    {
      label: "费用总额",
      prop: "totalAmount",
      key: "totalAmount",
    },
    {
      label: "本次使用",
      prop: "thisAmount",
      key: "thisAmount",
    },
  ];
  public centralPacking = [
    {
      label: "装箱单号",
      prop: "code",
      key: "code",
    },
    {
      label: "进仓单/报关计划",
      prop: "parentCode",
      key: "parentCode",
    },
    {
      label: "入库日期",
      prop: "actualWarehouseInTime",
      key: "actualWarehouseInTime",
    },
    {
      label: "账期",
      prop: "accountPeriod",
      key: "accountPeriod",
    },
    {
      label: "出货数量",
      prop: "quantity",
      key: "quantity",
    },
    {
      label: "出货金额",
      prop: "amount",
      key: "amount",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
    },
  ];
}
